"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDateFormatter = exports.isDateTime = void 0;
const tslib_1 = require("tslib");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const moment_1 = tslib_1.__importDefault(require("moment"));
const dateFormatMap = {
    en: {
        timeShort: 'h:mm A',
        dateShort: 'D MMM, YYYY',
        dayDate: 'dddd[,] D MMM, YYYY',
        dateTime: 'D MMM, YYYY | h:mm A',
    },
    de: {
        timeShort: 'HH:mm',
        dateShort: 'DD.MM.YYYY',
        dayDate: 'dddd[,] DD.MM.YYYY',
        dateTime: 'DD.MM.YYYY | HH:mm',
    },
};
const isDateTime = (date) => {
    if (!date || !date.toString().includes('T')) {
        return false;
    }
    return true;
};
exports.isDateTime = isDateTime;
const useDateFormatter = () => {
    const { current } = (0, frontend_infra_localisation_1.useI18n)();
    const formatDate = (format, date, utcOffset) => {
        if (!date) {
            return '-';
        }
        let formattedDate = (0, moment_1.default)(date).locale(current);
        if (utcOffset != null) {
            formattedDate = formattedDate.utcOffset(utcOffset * 60);
        }
        return formattedDate.format(format);
    };
    return {
        formatTimeShort: (date, utcOffset) => formatDate(dateFormatMap[current].timeShort, date, utcOffset),
        formatDateShort: (date, utcOffset) => formatDate(dateFormatMap[current].dateShort, date, utcOffset),
        formatDayDate: (date, utcOffset) => formatDate(dateFormatMap[current].dayDate, date, utcOffset),
        formatDateTime: (date, utcOffset) => formatDate(dateFormatMap[current].dateTime, date, utcOffset),
    };
};
exports.useDateFormatter = useDateFormatter;
//# sourceMappingURL=useDateFormatter.js.map